/* import __COLOCATED_TEMPLATE__ from './email-phone-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();